import { computed, effect, signal } from "@preact/signals-react"

export const imageModal = signal(null)
export const titleModal = signal('')
export const extraColumnInfo = signal(null)

export const openImageModal = computed(() => (imageModal.value !== null))

//Effects: Empty title on image close.
effect(() => imageModal.value === null ? titleModal.value = '' : null)